module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', [_vm._v("Exemple 1")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    attrs: {
      "id": "example-1"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n      " + _vm._s(item.message) + "\n    ")])
  })), _vm._v(" "), _c('h2', [_vm._v("Exemple 2")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    attrs: {
      "id": "example-2"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n      " + _vm._s(_vm.parentMessage) + " - " + _vm._s(index) + " - " + _vm._s(item.message) + "\n    ")])
  })), _vm._v(" "), _c('h2', [_vm._v("V-for")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('li', {
      staticClass: "list-group-item"
    }, [_vm._v(_vm._s(item.message))])]
  })], 2), _vm._v(" "), _c('h2', [_vm._v("Repeat object")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    attrs: {
      "id": "repeat-object"
    }
  }, _vm._l((_vm.object), function(value, key) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n      " + _vm._s(key) + " : " + _vm._s(value) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4a05bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list-renderer.vue
// module id = 89
// module chunks = 0